<template>
  <div class="callup">
    <div class="item box" v-for="item in callup" v-bind:key="item.pdf">
      <title class="color bold larger text-center row">{{item.text}}</title>
      <a target="_blank" :href="item.pdf">
        <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false">
          <template slot="loading">

          </template>
        </pdf>
      </a>
    </div>
  </div>
</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'Entente',
    components: {
      pdf
    },
    created() {
      this.callup = [
        {
          text: "ENTENTE - U11F U13F U15F",
          pdf: "https://www.asspm.fr/Convocations_U11F_U13F_U15F.pdf"
        },
        {
          text: "ENTENTE - U18F",
          pdf: "https://www.asspm.fr/Convocations_U18F.pdf"
        }
      ];
    }
  }
</script>

<style scoped lang="stylus">
  .callup
    title
      display block
    .item
      position relative
      max-width 920px
</style>
